<template>
  <div
    class="hero is-fullheight fullpage-section fondo"
    data-anchor="section-quienes-somos"
    :style="fondo"
  >
    <div class="quienes-somos-content">
      <div class="columns is-10-desktop is-centered is-mobile margin-top-off">
        <div
          class="column is-4-desktop is-6-tablet is-7-mobile background-content quienes-somos-content"
          align="center"
        >
          <div
            class="column is-hidden-mobile is-hidden-tablet-only margin-title"
          ></div>
          <div
            class="column hidden is-hidden-desktop margin-title-mobile"
          ></div>
          <div class="column is-paddingless">
            <h2 class="font-title size-title">SOMOS CALCE</h2>
          </div>
          <div class="column is-marginless hidden"></div>
          <div class="column is-size-4-tablet-only is-size-5-landscape is-size-4-desktop-only">
            Somos <strong>innovacion tecnológica</strong> al servicio de la
            <strong>rehabilitacion</strong>, entregando
            <strong>calidad</strong> , <strong>precisión</strong> y
            <strong>eficiencia</strong>.
          </div>
          <div class="column is-marginless is-hidden-touch"></div>
          <div class="column margin-to-bottom is-paddingless">
            <div
              class="column is-paddingless content is-size-5-landscape is-size-4-tablet-only is-size-4-desktop-only"
            >
              Más de <strong>300 personas</strong> hoy
              <strong>caminan</strong> con nuestros productos. Trabajamos con
              con las instituciones <strong>más importantes del país en rehabilitación</strong> y
              hemos presentado con <strong>éxito</strong> nuestro trabajo en
              <strong>congresos internacionales relacionados</strong>.
              <hr class="bar is-hidden-desktop" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getImg } from "@/utils/AssetsHelper"
import { pageIsTouch } from "@/utils/config/viewportsConfig"

export default {
  methods: {
    getImg,
    isDesktop() {
      return !pageIsTouch(this.$currentViewport)
    }
  },
  data() {
    return {

    }
  }
}
</script>

<style scoped>
.fondo {
  background-image: url(../../assets/img/fondos/fondoQuienes2020.jpg);
  background-size: cover;
}

.quienes-somos-content {
  height: 100vh;
}

.font-title {
  font-family: "Unica One", sans-serif;
}

.size-title {
  font-size: 6vh;
}

@media screen and (min-width: 700px) and (min-height: 600px) {
  .is-size-4-tablet-only {
    font-size: 2rem !important;
  }
}

@media screen and (min-width: 1080px) and (min-height: 600px) {
  .is-size-4-desktop-only {
    font-size: 1.5rem !important;
  }
}

@media screen and (orientation: landscape) {
  .hidden {
    display: none !important;
  }
  .is-size-5-landscape {
    font-size: 1rem;
  }
}

.background-content {
  background: rgba(255, 255, 255, 0.5);
}

.margin-title {
  height: 10vh;
}

.margin-title-mobile {
  height: 9vh;
}

.margin-top-off {
  margin-top: 0;
}

.bar {
  width: 15vw;
  background-color: #f39e52;
}
</style>
